// https://observablehq.com/@mbostock/tadpoles
class Bubbles {

	constructor(el) {
		this.width = window.innerWidth
		|| document.documentElement.clientWidth
		|| document.body.clientWidth;

		this.height = window.innerHeight
		|| document.documentElement.clientHeight
		|| document.body.clientHeight;


		let n = 8;
		let v = .4;
		let m = 12;
		let canvas = el;
		canvas.setAttribute('width', this.width)
		canvas.setAttribute('height', this.height)

		this.context = canvas.getContext('2d');

        let colors = ['#FF5362', '#D0FFEB', '#FFC5CC'];

		this.tadpoles = new Array(n).fill().map(() => ({
			vx: (Math.random()) * v,
			vy: (-Math.random()) * v,
			px: new Array(m).fill(Math.random() * this.width),
			py: new Array(m).fill(Math.random() * this.height),
			count: 0,
			innerSize: this.randomIntFromInterval(5,20),
            color: colors[this.randomIntFromInterval(0,colors.length -1)]
		}));

		this.hearts = new Array(5).fill().map(() => ({
			vx: -0.1,
			vy: (-Math.random()) * (v),
			px: new Array(m).fill(Math.random() * this.width),
			py: new Array(m).fill(Math.random() * this.height),
			count: 0,
			innerSize: this.randomIntFromInterval(5,20),
            color: colors[this.randomIntFromInterval(0,colors.length -1)]
		}));


		setInterval(() => this.draw(), 10);
	} 

    randomIntFromInterval(min, max) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
    }

    draw() {
		this.context.clearRect(0, 0, this.width, this.height);

        this.drawHearts()
        this.drawBubbles();
    }

    drawHearts() {
		this.context.clearRect(0, 0, this.width, this.height);
		
		for (const t of this.hearts) {
			let dx = t.vx;
			let dy = t.vy;
			let x = t.px[0] += dx;
			let y = t.py[0] += dy;

			
			// let speed = Math.sqrt(dx * dx + dy * dy);
			// const count = speed * 10;
			// const k1 = -5 - speed / 8;

			// Bounce off the walls.
			if (x < -50 || x > this.width) {
				t.px[0] = this.randomIntFromInterval(this.width * 0.3, this.width); 
				t.py[0] = this.height;
			}

			if (y < -50 || y > this.height) {
				t.px[0] = this.randomIntFromInterval(this.width * 0.3, this.width); 
				t.py[0] = this.height;
			} 

			// circle
			this.context.save();
			this.context.translate(t.px[0], t.py[0]);
			this.context.rotate(-10 * Math.PI / 180);

            this.context.fillStyle = t.color;
            this.context.beginPath();
            this.context.moveTo(49.1987,20.2876);
            this.context.lineTo(49.3411,8.89743);
            this.context.lineTo(42.7508,0.683337);
            this.context.lineTo(32.0593,0.549622);
            this.context.lineTo(25.2657,8.59633);
            this.context.lineTo(18.6754,0.382234);
            this.context.lineTo(7.98394,0.248519);
            this.context.lineTo(1.19031,8.29523);
            this.context.lineTo(1.04786,19.6854);
            this.context.lineTo(24.804,45.5102);
            this.context.lineTo(49.1987,20.2876);
            this.context.closePath();
            this.context.fill();
            this.context.restore();

        }
    }
      
	drawBubbles() {
		
		for (const t of this.tadpoles) {
			let dx = t.vx;
			let dy = t.vy;
			let x = t.px[0] += dx;
			let y = t.py[0] += dy;
			// let speed = Math.sqrt(dx * dx + dy * dy);
			// const count = speed * 10;
			// const k1 = -5 - speed / 8;

			// Bounce off the walls.
			if (x < 0 || x > this.width) t.px[0] = 0;
			if (y < -10 || y > this.height) t.py[0] = this.height;

			// circle
			this.context.save();
			this.context.translate(t.px[0], t.py[0]);
			this.context.rotate(Math.atan2(t.vy, t.vx));
			this.context.beginPath();
			this.context.fillStyle = t.color;
			this.context.ellipse(0, 0, t.innerSize, t.innerSize, 0, 0, 2 * Math.PI);
			this.context.fill();

			this.context.restore();
		}
	}
}

export default Bubbles;